// extracted by mini-css-extract-plugin
export var avatarContainer = "_bc-0";
export var avatarTypingWave = "_bc-i";
export var gray = "_bc-f";
export var green = "_bc-c";
export var icon = "_bc-9";
export var image = "_bc-1";
export var lg = "_bc-6";
export var md = "_bc-5";
export var presenceDot = "_bc-b";
export var red = "_bc-d";
export var sm = "_bc-4";
export var status = "_bc-a";
export var typingDot = "_bc-h";
export var typingPill = "_bc-g";
export var xl = "_bc-7";
export var xs = "_bc-3";
export var xxl = "_bc-8";
export var xxs = "_bc-2";
export var yellow = "_bc-e";